import React, { useState, useEffect, FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "../../components/Component"; // Assuming these are properly typed elsewhere
import { useSelector } from "react-redux";
import { RootState } from "../../store/store"; // Adjust this import based on your store configuration

interface InvoiceRequestAsideProps {
  updateSm: (value: boolean) => void; // Function to update state
  sm: boolean; // Boolean state
}

const InvoiceAside: FC<InvoiceRequestAsideProps> = ({ updateSm, sm }) => {
  const { data: allowedRoutes }: any = useSelector(
    (state: RootState) => state.allowedRoutes
  );
  const location = useLocation();

  useEffect(() => {
    sm
      ? document.body.classList.add("toggle-shown")
      : document.body.classList.remove("toggle-shown");
  }, [sm]);

  const isActive = (path: string): string => {
    return location.pathname === path ? "active" : "";
  };

  const LinkTo = ({ path }: { path: string }) => {
    // if (!allowedRoutes.includes(path)) {
    //   return null;
    // }
    switch (path) {
      case "view-e-invoice-list":
        return (
          <Link
            to="/view-e-invoice-list"
            className={isActive(
              `${process.env.PUBLIC_URL}/view-e-invoice-list`
            )}
          >
            <Icon name="plus-fill-c" />
            <span>Not Generated</span>
          </Link>
        );
      case "view-e-invoiced-list":
        return (
          <Link
            to="/view-e-invoiced-list"
            className={isActive(
              `${process.env.PUBLIC_URL}/view-e-invoiced-list`
            )}
          >
            <Icon name="check-fill-c" />
            <span>Generated</span>
          </Link>
        );
      case "view-e-invoice-cancelled-list":
        return (
          <Link
            to="/view-e-invoice-cancelled-list"
            className={isActive(
              `${process.env.PUBLIC_URL}/view-e-invoice-cancelled-list`
            )}
          >
            <Icon name="trash-fill" />
            <span>Cancelled</span>
          </Link>
        );
      case "view-e-invoice-expired-list":
        return (
          <Link
            to="/view-e-invoice-expired-list"
            className={isActive(
              `${process.env.PUBLIC_URL}/view-e-invoice-expired-list`
            )}
          >
            <Icon name="eye-fill" />
            <span>Expired</span>
          </Link>
        );
      case "view-e-invoice-excluded-list":
        return (
          <Link
            to="/view-e-invoice-excluded-list"
            className={isActive(
              `${process.env.PUBLIC_URL}/view-e-invoice-excluded-list`
            )}
          >
            <Icon name="activity-round-fill" />
            <span>Excluded</span>
          </Link>
        );
      default:
        return null;
    }
  };

  return (
    <div className="card-inner-group">
      <div className="card-inner">
        <div className="user-account-info py-0">
          <h6 className="overline-title-alt" style={{ fontSize: 14 }}>
            e-Way Bill
          </h6>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          {[
            "view-e-invoice-list",
            "view-e-invoiced-list",
            "view-e-invoice-cancelled-list",
            "view-e-invoice-expired-list",
            "view-e-invoice-excluded-list", 
          ].map((item) => (
            <li key={item} onClick={() => updateSm(false)}>
              <LinkTo path={item} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default InvoiceAside;
